import { Dialog } from "primereact/dialog"
import { FC, useEffect, useState } from "react"
import { LogsService } from "../../service/LogsService"
import { Log } from "../../types/logs"
import LogDetails from "./LogDetails"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { formatLogs } from "./utils"

export const LogsPage: FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [logs, setLogs] = useState<Log[]>([])
  const [selectedLog, setSelectedLog] = useState<Log | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      setIsLoading(true)
      const response = await LogsService.get().then((response) => response)

      if (response?.length) {
        const formatted = formatLogs(response)
        setLogs(formatted)
      }

      setIsLoading(false)
    })()
  }, [])

  const handleListItemClick = (index: number) => {
    setShowModal(true)
    setSelectedLog(logs[index])
  }

  return (
    <div className="card">
      <h2>Activity Logs</h2>
      <div>
        {isLoading ? (
          <>Loading...</>
        ) : logs.length ? (
          <DataTable value={logs} removableSort tableStyle={{ minWidth: "50rem" }}>
            <Column field="order_id" header="Order ID" sortable style={{ width: "25%" }}></Column>
            <Column field="creation_time" header="Created at" sortable style={{ width: "25%" }}></Column>
            <Column field="sync_time" header="Synced at" sortable style={{ width: "25%" }}></Column>
            <Column field="status" header="Status" sortable style={{ width: "25%" }}></Column>
          </DataTable>
        ) : (
          <div>
            <span>There are no logs to display.</span>
          </div>
        )}
      </div>

      <Dialog
        visible={showModal}
        style={{ width: "50vw" }}
        onHide={() => {
          setShowModal(false)
          setSelectedLog(null)
        }}
      >
        {selectedLog && <LogDetails log={selectedLog} />}
      </Dialog>
    </div>
  )
}
